/**
 * Array.prototype.at is used by web-vitals@5 (pulled in by Sentry / PostHog).
 * Older Android WebViews (Chrome before 92) throw TypeError without this.
 * Keep this as the first runtime import in main.ts.
 *
 * Spec-aligned rough polyfill from the relative-indexing proposal.
 */
function at<T>(this: ArrayLike<T>, n: number): T | undefined {
  const len = this.length;
  let index = Math.trunc(n) || 0;
  if (index < 0) index += len;
  if (index < 0 || index >= len) return undefined;
  return this[index];
}

export function installArrayAtPolyfill(): void {
  if (typeof Array === 'undefined' || typeof Array.prototype.at === 'function') {
    return;
  }
  Object.defineProperty(Array.prototype, 'at', {
    value: at,
    writable: true,
    enumerable: false,
    configurable: true,
  });
}

installArrayAtPolyfill();
